import fetch from '@/utils/fetch';

// 重新获取token
export function getTokens(){
  return fetch({
    url: '/login',
    method: 'get',
  });
}

export function getInfo(){
  return fetch({
    url: '/api/mchUser/info',
    method: 'get',
  })
}
// 登录
export function login(){
  return fetch({
    url: '/login',
    method: 'get'
  });
}




// WEBPACK FOOTER //
// ./src/api/login.js